import { useRecoilState } from 'recoil'

import { drawerState } from '~/src/recoil'

/**
 * useDrawer
 * drawer hooks
 * @example
 * ```ts
 *  const {
 *  isDrawerOpen,
 *  handleDrawerOpen,
 *  handleDrawerClose } = useDrawer()
 * ```
 * @category ReactHooks
 * @returns
 */
export const useDrawer = () => {
  // usage Recoil
  const [isDrawerOpen, setDrawerOpen] = useRecoilState<boolean>(drawerState)

  /**
   * handleDrawerOpen
   */
  const handleDrawerOpen = () => {
    setDrawerOpen(true)
  }

  /**
   * handleDrawerClose
   */
  const handleDrawerClose = () => {
    setDrawerOpen(false)
  }

  return { isDrawerOpen, handleDrawerOpen, handleDrawerClose }
}
